<template>
  <UIBadgeNew v-if="variant" :variant="variant">
    <template #icon>
      <BoltSlashIcon
        v-if="charge === 0"
        class="h-[14px] w-[14px]"
        :class="boltClass"
      />
      <BoltIcon v-else class="h-[14px] w-[14px]" :class="boltClass" />
    </template>
    <template #default>
      <span class="text-[13px] font-semibold">{{ charge }}%</span></template
    >
  </UIBadgeNew>
</template>

<script>
import { BADGE_VARIANT } from '@/components/ui/UIBadgeNew/utils';
import { getBatteryTier } from '@gpx-spa/constants';

const TIER_VARIANT = {
  empty: BADGE_VARIANT.default,
  low: BADGE_VARIANT.error,
  medium: BADGE_VARIANT.warning,
  high: BADGE_VARIANT.success,
};

const TIER_BOLT_CLASS = {
  empty: 'text-gpx_gray-200',
  low: 'text-gpx_red-200',
  medium: 'text-gpx_yellow-200',
  high: 'text-gpx_green-200',
};

export default {
  props: {
    charge: Number,
  },
  computed: {
    tier() {
      return getBatteryTier(this.charge);
    },
    variant() {
      return this.tier === 'unknown' ? null : TIER_VARIANT[this.tier];
    },
    boltClass() {
      return this.tier === 'unknown' ? '' : TIER_BOLT_CLASS[this.tier];
    },
  },
};
</script>
